import { render, staticRenderFns } from "./StrPerfDonemAlt.vue?vue&type=template&id=c4b009ac"
import script from "./StrPerfDonemAlt.vue?vue&type=script&lang=js"
export * from "./StrPerfDonemAlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports